var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 28,
    viewBox: "0 0 80 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.311 0C78.3232 0 79.9555 1.57817 80.0004 3.54395C80.0009 3.52932 80.003 3.51471 80.0033 3.5C80.0033 3.5 79.9828 21.708 79.9828 24.043C79.9827 26.236 77.9579 28 75.5483 28H11.016C10.1379 28 9.30067 27.6665 8.70256 27.082L0.844163 19.8496C-0.279451 18.7499 -0.275533 17.047 0.848069 15.9473L8.76994 7.90332C9.36806 7.32203 10.2019 6.99219 11.0766 6.99219H73.9877L74.0033 0H76.311Z",
    fill: "#B32318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7317 22.4545L44.0264 13H46.21L47.775 19.5692H47.8535L49.58 13H51.4497L53.1717 19.5831H53.2548L54.8197 13H57.0033L54.2981 22.4545H52.3499L50.5495 16.2731H50.4756L48.6798 22.4545H46.7317Z",
    fill: "#FEF3F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6435 22.4545V13H43.0143V14.6481H38.6425V16.9009H42.6865V18.549H38.6425V20.8065H43.0327V22.4545H36.6435Z",
    fill: "#FEF3F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.992 13V22.4545H33.2654L29.1521 16.5039H29.0829V22.4545H27.084V13H28.8382L32.9192 18.946H33.0023V13H34.992Z",
    fill: "#FEF3F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0033 3.54C79.9533 1.57 78.3233 0 76.3133 0H74.0033L74.0033 1H75.0033L76.0233 0.99C77.5333 0.99 79.0033 2.19 79.0033 3.63C79.0033 4.44 78.8633 5.01 78.6633 5.43C78.4633 5.84 78.1733 6.16 77.7733 6.42C77.5033 6.59 77.1933 6.74 76.8433 6.87C76.5233 6.94 76.1833 6.98 75.8433 6.99H10.9133C10.1033 7.03 9.33334 7.36 8.77334 7.9L0.843343 15.95C-0.276657 17.05 -0.285837 18.7496 0.844163 19.8496L8.70334 27.08C9.26334 27.63 10.0333 27.96 10.8533 27.99H75.5433C77.8733 27.99 79.8533 26.33 79.9733 24.24V24.04C79.9733 21.71 80.0033 3.5 80.0033 3.5C80.0033 3.51 80.0033 3.53 80.0033 3.54ZM78.9933 12.89C78.9933 17.73 78.9933 22.87 78.9933 24.04C78.9933 25.57 77.5333 27 75.5633 27H11.0133C10.3833 27 9.80334 26.76 9.40334 26.37H9.39334L9.38334 26.35L1.53334 19.13C0.823343 18.42 0.823343 17.37 1.54334 16.67V16.66L9.45334 8.63C9.85334 8.24 10.4333 8 11.0633 8H75.6033C77.5033 8 78.0333 7.62 79.0033 7C79.0033 8.65 78.9933 10.78 78.9933 12.91V12.89Z",
    fill: "#F97066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadge);
export default __webpack_public_path__ + "static/media/new-badge.db4857282e5f8159b12ccd9de679bbd9.svg";
export { ForwardRef as ReactComponent };